
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewards/about",
      function () {
        return require("private-next-pages/rewards/about/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewards/about"])
      });
    }
  